import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import EditTransactionComp  from "./Component/EditTransactionComp"

const EditTransaction =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditTransactionComp />
        </div>
        <Footer />
        </>
    )
}

export default EditTransaction